<h2 mat-dialog-title>Saída de Lotes</h2>

<mat-dialog-content>
  <div class="produto-info">
    <span class="produto-nome">{{ nomeProduto }}</span>
    @if (skuProduto) {
      <span class="produto-sku">SKU: {{ skuProduto }}</span>
    }
    <span class="status-badge status-qtd"
          [class.badge-vermelho]="statusBadge === 'vazio'"
          [class.badge-amarelo]="statusBadge === 'parcial'"
          [class.badge-verde]="statusBadge === 'ok'">
      {{ isNarrow ? 'Qtd. necessária' : 'Quantidade necessária' }}: {{ quantidadeTotal | number:'1.2-4' }}
      / {{ isNarrow ? 'Qtd. informada' : 'Quantidade informada' }}: {{ totalDistribuido | number:'1.2-4' }}
    </span>
  </div>

  @if (temLinhaExcedida) {
    <app-alert-card type="warning">
      Um ou mais lotes têm quantidade de saída maior que o saldo disponível. Ajuste os valores em vermelho para confirmar.
    </app-alert-card>
  }

  @if (isLoading) {
    <div class="loading-row">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Carregando lotes disponíveis…</span>
    </div>
  }

  @if (erroCarga) {
    <div class="error-banner">{{ erroCarga }}</div>
  }

  @if (!isLoading && dataSource.data.length === 0) {
    <div class="empty-contacts">Nenhum lote com saldo disponível nesta localização.</div>
  } @else if (isNarrow) {
    <div class="modal-card-list">
      @for (row of dataSource.data; track row) {
        <div class="modal-card">
          <div class="modal-card__header">
            <span class="modal-card__title">{{ row.codigoLote }}</span>
          </div>
          <div class="modal-card__body">
            <div class="modal-card__grid">
              <div class="modal-card__ro">
                <small>Validade</small>
                <span [class.vencido]="row.dataValidade && isVencido(row.dataValidade)">
                  {{ row.dataValidade ? (row.dataValidade | date:'dd/MM/yyyy') : '—' }}
                </span>
              </div>
              <div class="modal-card__ro">
                <small>Disponível</small>
                <span>{{ row.saldoDisponivel | number:'1.2-4' }}</span>
              </div>
            </div>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" [class.campo-excedido]="isLinhaExcedida(row)">
              <mat-label>Qtd. Saída</mat-label>
              <input matInput type="text" inputmode="decimal" [currencyMask]="quantidadeMask" [(ngModel)]="row.quantidadeSaida"
                placeholder="0,00" />
            </mat-form-field>
            @if (isLinhaExcedida(row)) {
              <span class="lote-erro-msg">Excede o saldo disponível do lote ({{ row.saldoDisponivel | number:'1.2-4' }}).</span>
            }
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="table-responsive mt-2">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z0 w-100 modal-tabela-cards">

        <ng-container matColumnDef="codigoLote">
          <th mat-header-cell *matHeaderCellDef>Lote</th>
          <td mat-cell *matCellDef="let row">{{ row.codigoLote }}</td>
        </ng-container>

        <ng-container matColumnDef="dataValidade">
          <th mat-header-cell *matHeaderCellDef>Validade</th>
          <td mat-cell *matCellDef="let row" [class.vencido]="row.dataValidade && isVencido(row.dataValidade)">
            {{ row.dataValidade ? (row.dataValidade | date:'dd/MM/yyyy') : '—' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="saldoDisponivel">
          <th mat-header-cell *matHeaderCellDef>Disponível</th>
          <td mat-cell *matCellDef="let row">{{ row.saldoDisponivel | number:'1.2-4' }}</td>
        </ng-container>

        <ng-container matColumnDef="quantidadeSaida">
          <th mat-header-cell *matHeaderCellDef>Qtd. Saída</th>
          <td mat-cell *matCellDef="let row">
            <mat-form-field appearance="outline" class="field-qtd" subscriptSizing="dynamic" [class.campo-excedido]="isLinhaExcedida(row)">
              <input matInput type="text" inputmode="decimal" [currencyMask]="quantidadeMask" [(ngModel)]="row.quantidadeSaida"
                placeholder="0,00" [matTooltip]="isLinhaExcedida(row) ? ('Excede o saldo disponível do lote (' + (row.saldoDisponivel | number:'1.2-4') + ').') : ''"
                [matTooltipDisabled]="!isLinhaExcedida(row)" />
            </mat-form-field>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  }

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button mat-flat-button class="btn-primary" (click)="confirmar()" [disabled]="!totalOk || temLinhaExcedida">Confirmar</button>
</mat-dialog-actions>
